import React from 'react'
import { ListButton, ShowButton, RefreshButton, TopToolbar, Toolbar, SaveButton, CreateButton } from 'react-admin'



export const CreateActions = ({ basePath, data, resource }) => (
    <TopToolbar>
      <ListButton basePath={ basePath } record={ data } />
      <RefreshButton basePath={ basePath } record={ data } />
    </TopToolbar>
  );

  export const CreateToolbar = ({ ...props }) => (
    <Toolbar { ...props }>
      <SaveButton
        label='Save'
        redirect='list'
        submitOnEnter
      />
    </Toolbar>
  )